import { render, staticRenderFns } from "./ViewAnswerModal.vue?vue&type=template&id=2e8c68c3&scoped=true&"
import script from "./ViewAnswerModal.vue?vue&type=script&lang=js&"
export * from "./ViewAnswerModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewAnswerModal.vue?vue&type=style&index=0&id=2e8c68c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c68c3",
  null
  
)

export default component.exports